import isAbsoluteUrl from 'onyx-common/isAbsoluteUrl'

const isRelativeUrl = url => !isAbsoluteUrl(url)

export default isRelativeUrl
